import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';



const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  text-align: left;

  &, & * {
    box-sizing: border-box;
  }
`;
const Container = styled.div.withConfig({displayName:'-Container'})`
  position: relative;
  display: block;
  width: ${props => props.width};
  max-width: 100%;
`;

const Selected = styled.div.withConfig({displayName:'-Selected'})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding: ${props => props.searchable && !props.selected ? "0px" : "0px 30px 0px 10px"};
  cursor: pointer;
  height: ${props => props.height};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: inherit;
  font-size: 12px;
  box-sizing: border-box;

  border-radius: 4px;



  ${props => props.open ? `
    &{
      border-bottom-left-radius: 0px !important;
    }
    &{
      border-bottom-right-radius: 0px !important;
    }
  ` : null }

  ${props => props.variant === "default" ? `
    box-shadow: ` + (props.searchable && props.open ? "inset" : "") + ` 0px 1px 2px #687FE262;
    background-color: #ffffff;
    border: 1px solid #CBCBCB;
    color: black;
  ` : props.variant === "blue" ? `
    background-color: #1d559c;
    border: 1px solid #1a4362;
    color: #FFFFFF;
  ` : null };
`;

const Text = styled.div.withConfig({displayName:'-Text'})`
  flex-grow: 1;
  flex-shrink: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ArrowContainer = styled.div.withConfig({displayName:'-ArrowContainer'})`
  position: absolute;
  content: "";
  top: 10px;
  right: 10px;
  height: calc(100% - 20px);
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const Arrow = styled.div.withConfig({displayName:'-Arrow'})`
  width: 16px;
  height: 16px;
  transition: all 0.15s ease-in-out;


  ${props => props.open ? `
    transform: rotate(180deg);
  ` : ``};
`;

const Placeholder = styled.div.withConfig({displayName:'-Placeholder'})`
  font-family: 'Be Vietnam Pro', sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.5px;

  ${props => props.variant === "default" ? `
    color: #dedede;
  ` : props.variant === "blue" ? `
    color: #FFFFFF;
  ` : null };

`;

const Options = styled.div.withConfig({displayName:'-Options'})`
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  right: 0;
  z-index: 99;
  box-shadow: 0px 1px 2px #687FE262;
  border-top: 0px solid transparent;
  border: 1px solid black;
  border-bottom: 0px;
  width: ${props => props.optionWidth ? props.optionWidth : "auto"};

  display: ${props => props.open ? "block" : "none"};

  ${props => props.maxHeight ? `
    max-height: ` + props.maxHeight + `;
    overflow-y: auto;
    overflow-x: visible;
  ` : ``};


  ${props => props.variant === "default" ? `
    background-color: #ffffff;
    border-color: #CBCBCB;
    color: black;
  ` : props.variant === "blue" ? `
    background-color: #1d559c;
    border-color: #1a4362;
    color: #FFFFFF;
  ` : null };

`;

const Option = styled.div.withConfig({displayName:'-Option'})`
  font-family: 'Be Vietnam Pro', sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;
  border: 1px solid transparent;
  cursor: pointer;
  min-height: ${props => props.height};

  ${props => props.variant === "default" ? `
    border-color: transparent transparent #CBCBCB;
    &:hover{
      background-color: lilac;
    }
  ` : props.variant === "blue" ? `
    border-color: transparent transparent transparent; /*border-color: transparent transparent #202833;*/
    &:hover{
      background-color: rgba(0, 0, 0, 0.1);
    }
  ` : null };



`;


const Label = styled.div.withConfig({displayName:'-Label'})`
  margin-top: 20px;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 300;
`;

const Search = styled.div.withConfig({displayName:'-Search'})`
  position: relative;
  height: calc(${props => props.height} - 2px);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;
const SearchIconContainer = styled.div.withConfig({displayName:'-SearchIconContainer'})`
  position: absolute;
  content: "";
  top: 10px;
  left: 8px;
  height: calc(100% - 20px);
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const SearchIcon = styled.div.withConfig({displayName:'-SearchIcon'})`
  width: 20px;
  height: 20px;
`;
const SearchInput = styled.input`
  position: absolute;
  top: 0px;
  ${props => props.open ? "right" : "left"}: 0px;
  font-family: 'Be Vietnam Pro', sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.5px;
  padding: 0px 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: inherit;
  outline: none;
  width: calc(100% - 24px);
  border: 0px;
  background-color: transparent;
  height: ${props => props.height};

  ${props => props.variant === "default" ? `
    color: ` + (props.disabled ? "#30303054" : "black") + `;
    ::placeholder {
      color: #dedede;
      opacity: 1;
    }
    :-webkit-autofill {
      box-shadow: inset 0 0 0px 9999px #ffffff;
    }
  ` : props.variant === "blue" ? `
      color: ` + (props.disabled ? "#30303054" : "#FFFFFF") + `;
      ::placeholder {
        color: #FFFFFF;
        opacity: 1;
      }
      :-webkit-autofill {
        box-shadow: inset 0 0 0px 9999px #ffffff;
      }
  ` : null };
`;

const Clear = styled.div.withConfig({displayName:'-Clear'})`
  z-index: 999;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 8px;
  width: calc(${props => props.height} - 16px);
  height: calc(${props => props.height} - 16px);
  background-color: lilac;
  border-radius: 3px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  /* box-shadow: 0px 1px 2px #687FE239; */

  &:hover{
    box-shadow: inset 0px 1px 2px #687FE239;
`;



const Select = ({
  label,
  placeholder,
  searchPlaceholder = "Search",
  values = [],
  selected = null,
  width,
  height = "34px",
  maxHeight,
  variant = "default",
  onChange = null,
  required = false,
  searchable,
  optionWidth = null,
  onSearch = () => {}
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [isFocus, setFocus] = useState("");
  const [indexSelected, setIndexSelected] = useState(null);
  const containerRef = useRef(null);
  const searchRef = useRef(null);

  useEffect(() => {
    function handler(e) {
      let newIndex;
      if(isFocus) {
        switch(e.keyCode){
          case 9: //Tab
            break;
          case 16: //Shift
            break;
          case 38: //ArrowUp
            e.preventDefault();
            if(!open){
              setOpen(true);
            }
            if(indexSelected === null || indexSelected === 0){
              newIndex = values.length - 1;
            }else{
              newIndex = indexSelected - 1;
            }
            setIndexSelected(newIndex);
            break;
          case 40: //ArrowDown
            e.preventDefault();
            if(!open){
              setOpen(true);
            }
            if(indexSelected !== null && indexSelected < values.length - 1){
              newIndex = indexSelected + 1;
            }else{
              newIndex = 0;
            }
            setIndexSelected(newIndex);
            break;
          case 13: //Enter
            e.preventDefault();
            setOpen(false);
            setSearch("");
            if(onSearch){onSearch("")};
            if(onChange){onChange(values[indexSelected].value);}
            setIndexSelected(null);
            break;
          case 27: //Escape
            e.preventDefault();
            // containerRef.current.focus();ado
            setOpen(false);
            setSearch("");
            if(onSearch){onSearch("")};
            setIndexSelected(null);
            break;
          default:
            if(!open){
              setOpen(true);
            }
            searchRef.current?.focus();
            break;
        }
      }
    }

    window.addEventListener('keydown', handler);

    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [isFocus, indexSelected, values, onChange, onSearch, open]);

  return (
    <Wrapper>
      {label ?
        <Label>
          {label} {required ? "*" : ""}
        </Label>
      : null}
      <Container
        ref={containerRef}
        width={width ? width : "260px"}
        isFocus={isFocus}
        onBlur={(e) => {
          // console.log("ONBLUR WRAPPER")
          // console.log(e);
          // console.log(e.target);
          // console.log(e.relatedTarget);
          if(!containerRef.current.contains(e.relatedTarget)){
            setTimeout(() => {
              setFocus(false);
              setSearch("");
              if(onSearch){onSearch("")};
              setOpen(false);
              setIndexSelected(null);
            }, 200);
          }
        }}
      >
        <Selected
          height={height}
          variant={variant}
          onClick={() => {setOpen(true)}}
          selected={selected}
          searchable={searchable}
          open={open}
          tabIndex="0"
          onFocus={() => {setFocus(true); setOpen(true);}}
        >
          {values.filter((item) => item.value === selected).length > 0 ?
            <Text>{values.filter((item) => item.value === selected)[0].name}</Text>
          : <Placeholder
              variant={variant}
            >
              {placeholder}
            </Placeholder>
          }
          <ArrowContainer>
            <Arrow open={open}>
              <i className="fa-solid fa-chevron-down"></i>
            </Arrow>
          </ArrowContainer>
        </Selected>
        <Options
          variant={variant}
          open={open}
          maxHeight={maxHeight ? maxHeight : null}
          optionWidth={optionWidth}
        >
          {searchable ?
            <Search
              height={height}
              variant={variant}
            >
              <SearchIconContainer>
                <SearchIcon>
                <i className="fa-solid fa-search"></i>
                </SearchIcon>
              </SearchIconContainer>
              <SearchInput
                ref={searchRef}
                height={height}
                open={open}
                variant={variant}
                onChange={(e) => {
                  setSearch(e.target.value);
                  if(onSearch){onSearch(e.target.value)};
                }}
                value={search}
                placeholder={searchPlaceholder}
                tabIndex="-1"
              />
              {search !== "" ?
                <Clear height={height} onClick={() => {
                  setSearch("");
                  if(onSearch){onSearch("")};
                }}>
                  <i className="fa-solid fa-x"></i>
                </Clear>
              : null }
            </Search>
          : null}
          {values.map((item, i) =>
            <Option
              height={height}
              variant={variant}
              key={i}
              onClick={(e) => {
                // console.log(e);
                // setOpen(false);
                // setIndexSelected(null);
                // setSearch("");
                // if(onSearch){onSearch("")};
                if(onChange){onChange(item.value);}
              }}
              selected={indexSelected === i}
            >{item.name}</Option>
          )}
        </Options>

      </Container>
    </Wrapper>
  )
}

export default Select;
